export default __webpack_public_path__ + "static/media/empty-cart.9fff9fe1.jpg";